/* eslint-disable react/function-component-definition */
import React, { useState } from 'react';
import type { FaixaDePreco } from '../../../../../@types/IPA/PrecoPsicologico';
import { ButtonVideo } from '../../../../ISA/InfoPanel/AnaliseCompetitividade/Components';
import { ModalTutorialVideo } from '../ModalTutorialVideo';
import { PsychologicalPriceHeader } from '../PsychologicalPriceHeader';

interface Props {
  faixas: FaixaDePreco[];
}

export function PrecoPsicologicoHeader({ faixas }: Props) {
  const [mostrarTutorial, setMostrarTutorial] = useState(false);

  const ultimaAtualizacao = React.useMemo(() => {
    if (faixas.length === 0) return undefined;
    const datas = faixas
      .map(f => f.atualizadoEm ?? f.criadoEm)
      .filter(Boolean)
      .sort();
    return datas[datas.length - 1];
  }, [faixas]);

  return (
    <>
      <PsychologicalPriceHeader
        mode="SIMPLIFIED"
        lastUpdate={ultimaAtualizacao}
        actions={<ButtonVideo onClick={() => setMostrarTutorial(true)} />}
      />

      <ModalTutorialVideo show={mostrarTutorial} onHide={() => setMostrarTutorial(false)} />
    </>
  );
}
